import React from "react";
import LoadMask from "Utils/LoadMask/LoadMask";
import { DiferenciasAcopioTable } from "../../../components/DiferenciasAcopioTable";
import { useDiferenciasAcopio } from "../hooks/useDiferenciasAcopio";
import { SeccionReporte } from "../../../components/SeccionReporte";

// La diferencia acopio de cada periodo del cierre, de la que sale la columna del
// comparativo. Va siempre abierta porque en los periodos compartidos con otros
// productos padre pide datos antes de poder cerrar. La referencia de traslados
// se muestra solo si hay alguno de esos periodos: sin ellos coincide con la
// diferencia
export const SeccionDiferenciasAcopio = ({ hook }) => {
    const diferencias = useDiferenciasAcopio(hook);

    return (
        <SeccionReporte
            titulo="Diferencia acopio por periodo"
            descripcion="Proporciona la diferencia acopio para el comparativo. En los periodos compartidos con otros productos padre, el valor se ingresa manualmente, con la diferencia de los traslados como referencia."
        >
            <LoadMask loading={diferencias.cargando} blur>
                <DiferenciasAcopioTable
                    periodos={diferencias.periodos}
                    edicion={diferencias}
                    mostrarReferencia={diferencias.hayPeriodosManuales}
                />
            </LoadMask>

            {diferencias.hayPeriodosManuales && (
                <div className="d-flex justify-content-end mt-3">
                    <button
                        className="btn btn-primary"
                        onClick={diferencias.guardarDiferencias}
                        disabled={diferencias.cargando || hook.cargando}
                    >
                        Guardar diferencias
                    </button>
                </div>
            )}
        </SeccionReporte>
    );
};
